import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function loginCSS() {
  return css`
    // width: 60%;
    margin: 0 auto;
    // padding-top: 3rem;
    

    .eyePassMobile{
      top: 50% !important;
    }

    .Container {
      min-height: 60px;
      min-width: 1px;
    }

    .ErrorMessage {
      /* background-color: #f8d7da; */
      color: #d9505e;
      padding: 10px;
      padding-left: 15px;
      /* border: 1px solid #f5c6cb; */
      border-radius: 5px;
      margin: 0.4rem 0;
      display: inline-block; /* Asegura que ocupe solo el espacio necesario */
    }
    .containerBtn {
      width: 100%;
      display: flex;
      @media (max-width: ${bpoints.mobile.w}px) {
        flex-direction: column;
        .ButtonContainer {
          width: 100%;

          // .Blue {
          //   width: 100% !important;
          // }
          // .Green {
          //   width: 100% !important;
          // }
        }
      }
    }

    .forgetPassword{
      a{
        color: #29588C;
        font-size: 1.1rem;
        font-weight: 500;
        text-decoration: none;
        cursor: pointer;
        :hover{
          text-decoration: underline;
        }
      }
    .SmallGray {
      font-size: calc(0.8rem + 0.5vw);
      font-style: normal;
      font-weight: 500;
      // line-height: 105.405%;
      cursor: pointer;

      color: #77787b;

      @media (max-width: ${bpoints.mobile.w}px) {
        font-size: calc(1rem + 1.1vw);
        color: black;
        margin-bottom: 4vh;
      }
    }}

    .title {
      font-size: calc(1.4rem + 0.7vw);
      color: #29588c;
      /* padding-bottom: 2rem; */

      @media (max-width: ${bpoints.mobile.w}px) {
        padding: 0 7vw;
        font-size: calc(1.4rem + 1.2vw);
      }
    }

    .FormContainer {
      width: 41.6%;

      @media (max-width: ${bpoints.mobile.w}px) {
        margin-top: 1rem;
        width: 90%;
      }

      .FormTitleContainer {
        width: 83.3%;

        @media (max-width: ${bpoints.mobile.w}px) {
          width: 100%;
          margin-top: 4vh;
        }
      }

      .ButtonContainer {
        @media (max-width: ${bpoints.mobile.w}px) {
          width: 100%;
        }
      }
    }

    .Button {
      font-size: calc(0.4rem + 0.7vw);
      position: relative;
      cursor: pointer;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;

      padding: 1rem 0;

      flex-basis: 0;
      flex-grow: 1;

      //transition: 300ms;
      @media (max-width: ${bpoints.mobile.w}px) {
        font-size: calc(0.9rem + 0.9vw);
      }
    }

    .Green {
      background-color: #22ec9a;
      color: white;

      border-radius: 17px !important;
      border: unset !important;
      :hover {
        background-color: #2ad690;
      }
    }
    .Blue {
      background-color: #32b8df;
      color: white;

      border-radius: 17px !important;
      border: unset !important;
      :hover {
        background-color: #2da5c8;
      }
    }
    .GradientLeft {
      border: none;
      outline: none;
      background: linear-gradient(to right, #34c6f1, #00ba6e);
      border-radius: 17px;
      z-index: 1;
      //transition: 200ms;

      :hover {
        background: #22ec9a;
      }

      ::before {
        content: "";
        position: absolute;
        left: 2px;
        right: 2px;
        top: 2px;
        bottom: 2px;
        border-radius: 15px;
        background-color: #f5fcfe;
        z-index: -1;
        transition: 200ms;

        @media (max-width: ${bpoints.mobile.w}px) {
          background-color: #e6f9ff;
        }
      }

      ::after {
        content: attr(data);

        color: #00ba6e;
        transition: 200ms;
      }
    }

    .GradientLeft:hover::before {
      background-color: #22ec9a;

      /* @media (max-width: ${bpoints.mobile.w}px){
                background-color: #e6f9ff;
            } */
    }

    .GradientLeft:hover::after {
      color: #fff;
      /* @media (max-width: ${bpoints.mobile.w}px){
                color: #00BA6E;
            } */
    }

    input::placeholder {
      color: #a7a9ac;
    }

    .TextInput {
      background-color: transparent;
      border-radius: 17px;
      border-color: #34c6f1;
      border-width: 1.5px;
      width: 100%;
      padding: 1rem 1.4rem;

      font-family: "Neue Haas Grotesk Display Pro" !important;
      font-style: normal;
      font-weight: 600;
      font-size: calc(0.2rem + 0.7vw);
      color: black;
      //height: 4.5rem;
      //font-size: 23px;
      @media (max-width: ${bpoints.tablet.w}px) {
        font-size: calc(0.8rem + 1vw);
      }

      ::placeholder {
        font-weight: 500;
        color: #a7a9ac;
      }
    }
    .shadowCard {
      margin-top: 1rem;
      height: 1.2rem;
      border-radius: 467px;
      background: radial-gradient(
        50.94% 44.66% at 49.86% 50.14%,
        rgba(0, 0, 0, 0.14) 0%,
        rgba(217, 217, 217, 0) 100%
      );
    }
  `;
}
